module.exports = __webpack_public_path__ + "fonts/Lato-Regular.8ab18d93.eot";